export default __webpack_public_path__ + "static/compareItemImg2-dc80293b7f7b71bd0b1bf9400086e7de.webp";